import { render, staticRenderFns } from "./IssuesInsights.vue?vue&type=template&id=2dbff2fd&"
import script from "./IssuesInsights.vue?vue&type=script&lang=js&"
export * from "./IssuesInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports